export default "__VITE_ASSET__DTzNGtIM__"